import { gql } from "config/graphql";
import { GQLUserResponse, ICoverageEditorPremium, TermUnit } from "config/types";
import { PRODUCT_DETAIL_FIELDS } from "gql/fragments";
import { gqlQuery } from "store/apollo";
import { createClientMutationId } from "utils/clientMutationId";

export interface IAdjustCoverageInput {
  id: string;
  termUnit: TermUnit;
  termDuration?: number;
  amount?: number;
}

interface IAdjustEstimateResponse {
  data: {
    adjustEstimate: ICoverageEditorPremium;
  };
}

export const adjustEstimateQuery = (
  estimate: IAdjustCoverageInput
): Promise<IAdjustEstimateResponse> => {
  const query = gql`
    query adjustEstimate($id: ID!, $termUnit: SharedTermUnit!, $termDuration: Int, $amount: Int) {
      adjustEstimate(id: $id, termUnit: $termUnit, termDuration: $termDuration, amount: $amount) {
        annualPremium
        monthlyPremium
        allocationsCoveredPercentage
      }
    }
  `;

  return gqlQuery<IAdjustEstimateResponse["data"]>({
    variables: {
      clientMutationId: createClientMutationId(),
      ...estimate,
    },
    query,
  });
};

export const fetchCurrentUserEstimate = (): Promise<GQLUserResponse<"activeConstellations">> => {
  const query = gql`
    ${PRODUCT_DETAIL_FIELDS}
    query latestEstimate {
      me {
        activeConstellations {
          activeInsuranceMembership {
            id
            coverageDetails {
              maximumApprovedCoverageAmount
              maximumApprovedTermDuration
              minimumApprovedCoverageAmount
              minimumApprovedTermDuration
              requestedCoverageAmount
              requestedTermDuration
              product {
                slug
              }
            }
            latestEstimateDatum {
              id
              termDuration
              termUnit
              amount
              health
              tobacco
              insuredsAgeAtTerm
              premiums {
                amount
                billingFrequency
              }
              product {
                ...ProductFields
              }
            }
          }
        }
      }
    }
  `;

  return gqlQuery<GQLUserResponse<"activeConstellations">["data"]>({ query });
};
